import { Button, Text, Tooltip } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

interface ReviewEntriesSelectionBarProps {
  blockedCount: number
  isProcessing: boolean
  isValidateDisabled: boolean
  onValidateSelection: () => void
  selectedCount: number
}

export const ReviewEntriesSelectionBar = ({
  blockedCount,
  isProcessing,
  isValidateDisabled,
  onValidateSelection,
  selectedCount,
}: ReviewEntriesSelectionBarProps): ReactElement | null => {
  const { t } = useTranslation()

  if (!selectedCount) {
    return null
  }

  const validateButton = (
    <Button
      disabled={isProcessing || isValidateDisabled}
      loading={isProcessing}
      onClick={onValidateSelection}
      size="sm"
    >
      {t('review_entries.selection.validate')}
    </Button>
  )

  return (
    <Styled.SelectionBarWrapper data-testid="review-entries-selection-bar">
      <Text variant="bodyMD" weight="medium">
        {t('review_entries.selection.selected', { count: selectedCount })}
      </Text>
      {isValidateDisabled && blockedCount > 0 ? (
        <Tooltip label={t('review_entries.selection.blocked', { count: blockedCount })} placement="top">
          {validateButton}
        </Tooltip>
      ) : (
        validateButton
      )}
    </Styled.SelectionBarWrapper>
  )
}
